<script>
import ListInfo from '@components/List/Info'

import { eventLocationTitle, eventSessionTimeTitle } from '@utils/zerone-event'
export default {
  components: {
    ListInfo,
  },
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      },
    },
    type: {
      type: String,
      default: 'member',
    },
  },
  data() {
    return {}
  },
  computed: {
    locationTitle() {
      return eventLocationTitle(this.item.type, this.item.categoryTitle)
    },
    sessionTimeTitle() {
      return eventSessionTimeTitle(this.item.type, this.item.categoryTitle)
    },
    locationContent() {
      return this.item.type === 'online'
        ? '依各場次詳情為主'
        : this.item.fullAddress
        ? `<a
                target="_blank" 
                href="https://www.google.com.tw/maps/search/${this.item.fullAddress}"
              >   
                ${this.item.locationName}(${this.item.fullAddress})<i class="fal fa-external-link ml-2"></i>
              </a>`
        : '----'
    },
    infoList() {
      return [
        {
          title: `<i class="icomoon icon-time mr-2"></i>${this.sessionTimeTitle}`,
          text: this.item.dateTimeRange,
          class: 'col-md-6 mt-4',
        },
        {
          title: `<i class="icomoon icon-location mr-2"></i>${this.locationTitle}`,
          text: this.locationContent,
          class: 'col-md-6 mt-md-4 mt-2',
        },
      ]
    },
  },
  methods: {
    goToBrand(item) {
      this.$router.push({
        name: 'brand-item',
        params: {
          brandAlias: item.alias,
        },
      })
    },
  },
}
</script>
<template>
  <div :class="$style.sectionMemberCourseList">
    <div class="row">
      <div class="col-lg-8 col-12 sectionMemberCourseList--left">
        <!-- FIX:多天多場的LIVE沒有 -->
        <div class="d-md-block d-none" :class="[item.type === 'online' ? 'mb-3' : 'mb-2']" style="height: 37px">
          <el-tag v-if="item.type === 'online'" class="isStylePrimary isAngle isOutline"> <i class="fas fa-circle fa-sm mr-2"></i>LIVE </el-tag>
        </div>
        <div class="row">
          <div class="col-12 sectionMemberCourseList__title mb-md-4 d-md-block d-none">
            {{ item.title }}
          </div>
          <el-divider class="mx-3 d-md-block d-none"></el-divider>
          <div class="col-12 px-md-0">
            <ListInfo :info-list="infoList" class="row sectionMemberCourseList__infoList mx-0" />
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-12 sectionMemberCourseList__img order-md-0 order-first d-lg-block d-none">
        <template v-if="!!item.brands.length">
          <div class="row align-content-center h-100" :class="{ 'justify-content-center': item.brands.length === 1 }">
            <div v-for="(brand, $index) in item.brands" :key="$index" class="col-6 mb-2 text-center" style="cursor: pointer" @click="goToBrand(brand)">
              <img :src="brand.logo" :alt="brand.title" />
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<style lang="scss" module>
.sectionMemberCourseList {
  overflow: hidden;
  background: #fff;
  box-shadow: 0 2px 10px rgba(33, 69, 88, 0.16);

  :global {
    .sectionMemberCourseList {
      &--left {
        position: relative;
        padding: 2.25rem 3.75rem 5.3125rem 3.75rem;
        @include max-lg {
          padding: 1.25rem 2.75rem 4.3125rem 2.75rem;
        }
        @include max-md {
          padding: 0;
          background: $color-gray-2;
        }
      }

      &__title {
        font-size: 24px;
        font-weight: 500;

        @include max-md {
          padding-right: 60px;
          font-size: 22px;
        }
      }
      &__infoList {
        font-size: 1.25rem;
        width: 100%;
        @include max-md {
          padding-bottom: 1.5rem;
          background: $color-gray-2;
          padding-left: $container-gap;
          padding-right: $container-gap;
        }
      }
      &__list {
        font-size: 20px;

        @include max-md {
          font-size: 18px;
        }
      }

      &__text {
        font-size: 16px;
      }

      &__img {
        // background: rgba(244, 246, 250, 1);
        padding-right: 38px;
        @include max-md {
          min-height: 200px;
          padding-right: auto;
        }

        // img {
        //   max-width: 230px;
        // }
      }
    }
  }
}
</style>
